<div class="quickview">
    <button class="quickview__close" type="button" appClick (click)="bsModalRef.hide()">
        <app-icon name="cross-20" size="20"></app-icon>
    </button>

    <h6>Come usiamo i cookie</h6>
    <p>Possiamo richiedere che i cookie siano impostati sul tuo dispositivo. Utilizziamo i cookie per farci sapere quando 
        visitate i nostri siti Web, come interagite con noi, per arricchire la vostra esperienza utente e per personalizzare 
        il vostro rapporto con il nostro sito web.<br>
        Puoi anche modificare alcune delle tue preferenze. Tieni presente che il blocco di alcuni tipi di cookie potrebbe influire sulla tua esperienza sui nostri siti Web e sui 
        servizi che siamo in grado di offrire.
    </p>

    <h6>Cookie strettamente necessari</h6>
    <p>Questi cookie sono strettamente necessari per fornirti i servizi disponibili attraverso il nostro sito Web e per 
        utilizzare alcune delle sue funzionalità.
        <br>
        Poiché questi cookie sono strettamente necessari per fornire il sito Web, non è possibile rifiutarli senza influire
        sul funzionamento del nostro sito. È possibile bloccarli o eliminarli modificando le impostazioni del browser e imporre 
        il blocco di tutti i cookie su questo sito Web.<br>
        <label><input type="checkbox" disabled checked>&nbsp;Cookie tecniche del sito (first-party cookie)</label>
        <br>
        <label><input type="checkbox" disabled checked>&nbsp;Cookie Stripe Payments</label>
    </p>

    <h6>Cookie di terze parti</h6>
    <p [formGroup]="form">Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare 
        e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più 
        e meno popolari e vedere come i visitatori si muovono nel sito. Tutte le informazioni raccolte 
        dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando 
        hai visitato il nostro sito e non saremo in grado di monitorare le tue prestazioni.<br>
        <label><input type="checkbox" formControlName="google_analytics">&nbsp;Google Analytics</label>
        <br>
        <label><input type="checkbox" formControlName="facebook_pixel">&nbsp;Facebook Pixel</label>
        <br>
        <label><input type="checkbox" formControlName="facebook_live_chat">&nbsp;Facebook Live Chat</label>
    </p>

    <h6>Privacy e Cookie policy</h6>
    <p>Leggi la nostra <a href="https://www.iubenda.com/privacy-policy/gdpr/67655323/cookie-policy" target="_blank">cookie policy</a> e la nostra 
        <a href="https://www.mytidy.it/privacy" target="_blank">privacy policy</a> per maggiori informaizioni.

    </p>

    <div class="d-flex justify-content-center">
        <button class="btn btn-primary" (click)="saveAndClose()">Salva</button>
    </div>
    
</div>